module.exports = __webpack_public_path__ + "static/media/navbar-ico-5.65d10e2c.svg";